module.exports = __webpack_public_path__ + "static/media/monet-6.dd619802.jpeg";